import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "battery" */ './index'),
  loading: () => null,
})
